import {Pipe, PipeTransform} from '@angular/core';
import { result } from 'lodash';

@Pipe({
  name: 'dataPropertyGetter',
  standalone: true
})
export class DataPropertyGetterPipe implements PipeTransform {

  transform(object: any, keyName: string, ...args: unknown[]): unknown {
    return result(object,keyName);
  }

}